import { CheckIcon } from '@zep-us/zus-icons';
import { ParseKeys } from 'i18next';
import { SubscribePlan } from '../../../types';
interface Feature {
  key: ParseKeys<['subscription']>;
  icon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
}

// 프라이싱 페이지와 문구·아이콘을 통일한다. 기능 아이콘은 전부 체크로 통일.
const renderCheckIcon = (props: React.SVGProps<SVGSVGElement>) => <CheckIcon {...props} data-sentry-element="CheckIcon" data-sentry-component="renderCheckIcon" data-sentry-source-file="SubscriptionConst.tsx" />;
export const FREE_NEW_FEATURES: Feature[] = [{
  key: 'subscription:pricing.free.feature2',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.free.feature4',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.free.feature5',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.free.feature3',
  icon: renderCheckIcon
}];
export const BASIC_NEW_FEATURES: Feature[] = [{
  key: 'subscription:pricing.oOskLOD6',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.basic.spotlightUnlimited',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.basic.screenShareUnlimited',
  icon: renderCheckIcon
}, {
  key: 'subscription:planFeatures.spaceSearchVisibility',
  icon: renderCheckIcon
}, {
  key: 'subscription:planFeatures.spacePassword',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.basic.loginUserOnly',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.basic.domainRestriction',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.basic.entryTitle',
  icon: renderCheckIcon
}];
export const PRO_NEW_FEATURES: Feature[] = [{
  key: 'subscription:pricing.pro.feature5',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.pro.feature2',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.pro.feature4',
  icon: renderCheckIcon
},
// 데이터 대시보드 (JA 는 Enterprise 로 이동)
{
  key: 'subscription:pricing.enterprise.feature2',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.pro.visitHistoryDownload',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.pro.messagePermission',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.pro.spotlightParticipantVideo',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.pro.connectionLostAlarm',
  icon: renderCheckIcon
}];
export const ENTERPRISE_NEW_FEATURES: Feature[] = [{
  key: 'subscription:pricing.enterprise.feature3',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.enterprise.feature4',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.enterprise.feature5',
  icon: renderCheckIcon
}];
export const BASIC_NEW_FEATURES_JA = BASIC_NEW_FEATURES;

// JA 는 데이터 대시보드(enterprise.feature2)를 Pro 에서 노출하지 않는다.
export const PRO_NEW_FEATURES_JA: Feature[] = [{
  key: 'subscription:pricing.pro.feature5',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.pro.feature2',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.pro.feature4',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.pro.visitHistoryDownload',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.pro.messagePermission',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.pro.spotlightParticipantVideo',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.pro.connectionLostAlarm',
  icon: renderCheckIcon
}];

// JA 는 데이터 대시보드를 Enterprise 최상단에서 노출.
export const ENTERPRISE_NEW_FEATURES_JA: Feature[] = [{
  key: 'subscription:pricing.enterprise.feature2',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.enterprise.feature3',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.enterprise.feature4',
  icon: renderCheckIcon
}, {
  key: 'subscription:pricing.enterprise.feature5',
  icon: renderCheckIcon
}];
export const SUBSCRIPTION_FEATURES: { [plan in SubscribePlan]: Feature[] } = {
  free: FREE_NEW_FEATURES,
  basic: FREE_NEW_FEATURES.concat(BASIC_NEW_FEATURES),
  pro: BASIC_NEW_FEATURES.concat(PRO_NEW_FEATURES),
  enterprise: BASIC_NEW_FEATURES.concat(PRO_NEW_FEATURES, ENTERPRISE_NEW_FEATURES)
};
export const SUBSCRIPTION_FEATURES_JA: { [plan in SubscribePlan]: Feature[] } = {
  free: FREE_NEW_FEATURES,
  basic: FREE_NEW_FEATURES.concat(BASIC_NEW_FEATURES_JA),
  pro: BASIC_NEW_FEATURES_JA.concat(PRO_NEW_FEATURES_JA),
  enterprise: BASIC_NEW_FEATURES_JA.concat(PRO_NEW_FEATURES_JA, ENTERPRISE_NEW_FEATURES_JA)
};
export const INFINITE_MAX_CCU = -1;